export default __webpack_public_path__ + "static/elsa-logo-03fa6150fd01268b26511b50717b93c5.png";